<template>
  <div class="print-table-head">
    <div class="print-table-head__title">
      <div style="font-size: 30px">{{ address }}</div>
      <div style="font-size: 20px">&nbsp;</div>
      <div style="font-size: 15px">
        公司地址：广州市海珠区新港东路277号赫基大厦
        &nbsp;&nbsp;&nbsp;&nbsp;公司总机：020-38155555&nbsp;&nbsp;传真:38155200-620
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "print-header",
  props: ["address"],
  methods: {},
  data() {
    return {};
  },
};
</script>

<style>
</style>